import { render, staticRenderFns } from "./CaptureWebCam.vue?vue&type=template&id=4fd1c40f&scoped=true&"
import script from "./CaptureWebCam.vue?vue&type=script&lang=js&"
export * from "./CaptureWebCam.vue?vue&type=script&lang=js&"
import style0 from "./CaptureWebCam.vue?vue&type=style&index=0&id=4fd1c40f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd1c40f",
  null
  
)

export default component.exports